// File Metadata:
// Filename: tokenService.js
// Version: 1.00
// Created: 2025-03-23 21:32:49
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import jwtDecode from 'jwt-decode'

let refreshPromise = null;

export const tokenService = {
    isTokenExpired(token) {
        if (!token) return true;
        try {
            const decoded = jwtDecode(token);
            return decoded.exp * 1000 < Date.now();
        } catch {
            return true;
        }
    },

    async refreshToken(baseQuery, api) {
        // If no refresh promise exists, create one
        if (!refreshPromise) {
            refreshPromise = (async () => {
                try {
                    const result = await baseQuery('/auth/refresh', api, {});
                    
                    // Check if we got a 401 (unauthorized)
                    if (result?.error?.status === 401) {
                        return { error: { status: 401, data: { message: 'Please login' } } };
                    }
                    
                    return result;
                } catch (err) {
                    return { error: err };
                } finally {
                    refreshPromise = null;
                }
            })();
        }
        return refreshPromise;
    },

    setToken(token) {
        if (token) {
            console.log('Setting token in localStorage');
            localStorage.setItem('token', token);
        }
    },
    getToken() {
        const token = localStorage.getItem('token');
        if (!token) return null;
        
        try {
            const decoded = jwtDecode(token);
            // Add 60 second buffer to token expiration
            const isValid = decoded.exp * 1000 > Date.now() - 60000;
            console.log('Token validation:', { isValid, expiresIn: decoded.exp * 1000 - Date.now() });
            return isValid ? token : null;
        } catch (err) {
            console.error('Token validation failed:', err);
            this.clearTokens();
            return null;
        }
    },
    clearTokens() {
        console.log('Clearing tokens'); // Debug log
        localStorage.removeItem('token');
    }
};
